// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__Mqq8x","listContainer":"Projects_listContainer__Edzd5"};